<template>
    <div class="canvas-login">
        <div class="header">
            <img src="/images/dfc-logo.svg"
                 alt="Design for Change USA"
                 class="logo">
        </div>
        <div class="container">
            <div class="content">
                <div class="card">
                    <div class="card-body text-center">

                        <div class="project-image">
                            <img :src="project_image" :alt="project?.name">
                        </div>

                        <h1 class="project-title">{{ project?.name }}</h1>

                        <hr>

                        <div class="theme">
                            <div class="theme-icon">
                                <img :src="theme.icon" alt="">
                            </div>
                            <div class="theme-details">
                                <strong>Goal:</strong>
                                <div class="theme-name">{{ theme?.name }}</div>
                            </div>
                        </div>

                        <p class="text">
                            If you are a member of <strong>{{ team?.name }}</strong>, choose your name below to view your project canvas.
                        </p>

                        <div class="team">
                            <inertia-link v-for="member in team.members" :key="member.id"
                                          :href="route('student.canvas2.login.submit', {uuid, ...global_url_params})"
                                          :data="{student_id: member.id}"
                                          method="post"
                                          class="member btn btn-outline-feel">
                                {{ member.name }}
                            </inertia-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <img src="/images/canvas2/login-footer-curve.svg" alt="" class="floating-bg">
            <img src="/images/canvas2/login-bg-circles-01.svg" alt="" class="bg-circle-01">
            <img src="/images/canvas2/login-bg-circles-02.svg" alt="" class="bg-circle-02">
        </div>
    </div>
</template>

<script>
import themes from "@/DATA/themes";

export default {
    name: "CanvasLogin",
    props: {
        canvas: {
            type: Object,
            default: () => null,
        }
    },

    computed: {
        project(){ return this.canvas?.project },
        team(){ return this.canvas?.team },
        uuid(){ return this.canvas?.uuid },
        theme(){ return themes.reduce((prev, val) => val.id == this.project?.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'}) },
        project_image(){ return `https://via.placeholder.com/280x160?text=${this.project?.name}` },
    }

}
</script>

<style lang="scss" scoped>
.canvas-login{
    background: #5dd8de linear-gradient(355deg, #9BF3F7 0%, #12C2E9 63%, #1FBBEE 100%) 0% 0% no-repeat;
}
.header{
    background: url("/images/canvas2/login-header-curve.svg") no-repeat center bottom / 400%;
    height: 160px;
    position: relative;

    @include media-breakpoint-up(sm){
        background: url("/images/canvas2/login-header-curve.svg") no-repeat center bottom / 300%;
    }

    @include media-breakpoint-up(md){
        background: url("/images/canvas2/login-header-curve.svg") no-repeat center bottom / 240%;
    }

    @include media-breakpoint-up(lg){
        background: url("/images/canvas2/login-header-curve.svg") no-repeat center bottom / 180%;
    }

    @include media-breakpoint-up(xl){
        background: url("/images/canvas2/login-header-curve.svg") no-repeat center bottom / 140%;
    }

    .logo{
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0%);
        width: 200px;
        height: auto;
    }
}

.content{
    max-width: 520px;
    min-height: 340px;
    margin: 0 auto;
    padding: 3rem 0;
}

.card{
    background: $light;
}

.project-image{
    img{
        display: inline-block;
        max-width: 100%;
        height: auto;
        margin-bottom: 1rem;
    }
}

.project-title{
    color: $feel;
    font-size: 2rem;
}

.footer{
    position: relative;

    .floating-bg{
        width: 100%;
        height: auto;
        user-select: none;
        pointer-events: none;
    }

    .bg-circle-01{
        position: absolute;
        left: 10%;
        bottom: 30%;
        user-select: none;
        pointer-events: none;
    }

    .bg-circle-02{
        position: absolute;
        right: 10%;
        bottom: 40%;
        user-select: none;
        pointer-events: none;
    }
}

hr{
    margin: 1.5rem 0;
}

.theme{
    display: flex;
    align-items: center;
    max-width: 420px;
    margin: auto auto 2rem;

    .theme-icon{
        width: 72px;
        flex: 0 0 72px;
        border-radius: .3rem;
        overflow: hidden;
    }

    .theme-details{
        display: block;
        flex: 1 1 auto;
        padding-left: 1rem;
        text-align: left;
        font-size: 1rem;
    }

    .theme-name{
        text-transform: uppercase;
        margin-top: 0.1rem;
    }

}

.text{
    font-size: 1.1rem;

    strong{
        color: $feel;
    }
}

.member{
    border-radius: 2rem;
    margin: 0.4rem 0.4rem;
}
</style>
